import { render, staticRenderFns } from "./CategoryMenu.vue?vue&type=template&id=12311752"
import script from "./CategoryMenu.vue?vue&type=script&lang=js"
export * from "./CategoryMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenu.vue?vue&type=style&index=0&id=12311752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports